import * as React from 'react';

import { Me, useMe } from '~/hooks/useMe';

export interface MeContextProps {
  me?: Me;
  loading: boolean;
  error: Error | null;
}

export const MeContext = React.createContext<MeContextProps>(null);

export const MeProvider = ({
  children,
}: React.PropsWithChildren): React.JSX.Element => {
  const { data: me, loading, error } = useMe();
  return (
    <MeContext.Provider value={{ me, loading, error }}>
      {children}
    </MeContext.Provider>
  );
};

export const useMeContext = (): Me => {
  const meContext = React.useContext(MeContext);
  return meContext.me;
};
